import TagService from "src/services/TagService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	name: ""
};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.tag,
@property  {array}  modules.tags
 **/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator("tag", TagService, module, types, params);
